const state = {
  activeFirstMenu:'',
  activeSecondMenu:'',
  activeThreeMenu:'',
  router:'',
  beian:{},
  firstbeian:{},
  beianzt:{},
  domain:{},
  vhost:{},
  vps:{},
  msg:{
    num:0,
    list:[]
  },
  delay:'first'
}
const getters = {
  getSecondMenu: state => {
    return state.activeSecondMenu
  },
  getThreeMenu: state => {
    return state.activeThreeMenu
  },
  getFirstMenu: state => {
    return state.activeFirstMenu
  },
  getBeian: state => {
    return state.beian
  },
  getMsg: state => {
    return state.msg
  },
  getDelay: state => {
    return state.delay
  }
}
const mutations = {
  setSecondMenu (state,val) {
    state.activeSecondMenu = val
    sessionStorage.setItem('secondMenu',val)
  },
  setThreeMenu (state,val) {
    state.activeThreeMenu = val
    sessionStorage.setItem('threeMenu',val)
  },
  setFirstMenu (state,val) {
    state.activeFirstMenu = val
    sessionStorage.setItem('firstMenu',val)
  },
  setRouter (state,val) {
    state.router = val
    sessionStorage.setItem('router',val)
  },
  setBeian (state,obj) {
    state.beian = obj
    sessionStorage.setItem('beian',obj)
  },
  firstBeian (state,obj) {
    state.firstbeian = obj
    sessionStorage.setItem('firstbeian',obj)
  },
  beianZt (state,obj) {
    state.beianobj = obj
    sessionStorage.setItem('beianzt',obj)
  },
  domain (state,obj) {
    state.domainobj = obj
    sessionStorage.setItem('domain',obj)
  },
  vhost (state,obj) {
    state.vhost = obj
    sessionStorage.setItem('vhost',obj)
  },
  vps (state,obj) {
    state.vps = obj
    sessionStorage.setItem('vps',obj)
  },
  msg (state,obj) {
    state.msg = obj
  },
  delay (state,val) {
    state.delay = val
  },
}
const actions = {
  SETSECOND_MENU ({commit, state},val) {
    commit('setSecondMenu',val)
  },
  SETTHREE_MENU ({commit, state},val) {
    commit('setThreeMenu',val)
  },
  SETFIRST_MENU ({commit, state},val) {
    commit('setFirstMenu',val)
  },
  SETROUTER ({commit, state},val) {
    commit('setRouter',val)
  },
  SETBEIAN ({commit, state},obj) {
    commit('setBeian',obj)
  },
  FIRSTBEIAN ({commit, state},obj) {
    commit('firstBeian',obj)
  },
  BEIANZT ({commit, state},obj) {
    commit('beianZt',obj)
  },
  DOMAIN ({commit, state},obj) {
    commit('domain',obj)
  },
  VHOST ({commit, state},obj) {
    commit('vhost',obj)
  },
  VPS ({commit, state},obj) {
    commit('vps',obj)
  },
  MSG ({commit, state},obj) {
    commit('msg',obj)
  },
  DELAY ({commit, state},val) {
    commit('delay',val)
  },
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/test.js